<template>
  <svg
    version="1.1"
    id="Calque_1"
    class="flat_hex_svg"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 225.4 86.5"
    style="enable-background:new 0 0 225.4 86.5;"
    xml:space="preserve"
  >
    <linearGradient
      id="SVGID_1_"
      gradientUnits="userSpaceOnUse"
      x1="0"
      y1="274.3048"
      x2="225.38"
      y2="274.3048"
      gradientTransform="matrix(1 0 0 -1 0 317.5446)"
    >
      <stop offset="0" style="stop-color:#F4EA09"></stop>
      <stop offset="1" style="stop-color:#DA5D27"></stop>
    </linearGradient>
    <polygon
      class="flat_hex_polygon"
      points="222.9,21 222.9,65.5 112.6,83.9 2.5,65.5 2.5,21 112.6,2.5"
    ></polygon>
  </svg>
</template>
<script>
export default {
  name: "flatHex"
};
</script>

<style>
.flat_hex_svg {
  position: absolute;
  background: transparent;

  /* padding-right: 15px; */
  fill: rgb(27, 31, 37);
  height: 50px;
  /* transition: 0.4s; */
}

.v-btn:hover .flat_hex_polygon {
  fill: #576575;
}

.flat_hex_polygon {
  fill: #1b2026;
  stroke: url(#SVGID_1_);
  stroke-width: 5;
  stroke-miterlimit: 10;
  transition: 0.2s;
}
</style>
